"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ ACCORDION ] ##########################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      hasBorder = _ref.hasBorder; // 2.1. FUNCTIONS ............................................................
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................

  return _react["default"].createElement(_index.AccordionContainer, {
    hasBorder: hasBorder
  }, children); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. DEFAULT VALUES .........................................................


Accordion.defaultProps = {}; // 3.1. END ....................................................................
// 3.2. TYPES ..................................................................

Accordion.propTypes = {
  /**  Contents within this component. */
  children: _propTypes["default"].node,

  /**  Contents within this component. */
  hasBorder: _propTypes["default"].bool
}; // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Accordion; // END OF FILE #################################################################

exports["default"] = _default;